var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaimPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5829 1.87249C12.1255 -0.0657378 9.21662 -0.0657343 7.75921 1.8725L1.30036 10.4623C-0.505116 12.8634 1.208 16.2949 4.21219 16.2949L17.1299 16.2949C20.1341 16.2949 21.8472 12.8634 20.0417 10.4622L13.5829 1.87249Z",
    fill: "#0FD08B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimPolygon);
export default __webpack_public_path__ + "static/media/claim-polygon.b4981dc3706124087dc28658dc59c4ab.svg";
export { ForwardRef as ReactComponent };